const GameError = ({error}: {error:string}) => {
    return (
        <div className='game-error fs-2 text-center p-1 p-sm-2'>
            <div dangerouslySetInnerHTML={{__html: error}}>
            </div>
        </div>
    );
}

export default GameError;